export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon/mountex/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon/mountex/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon/mountex/android-icon-96x96.png"},{"rel":"shortcut icon","href":"/favicon/mountex/favicon.ico"},{"rel":"apple-touch-icon","type":"image/png","sizes":"60x60","href":"/favicon/mountex/apple-icon-60x60.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"144x144","href":"/favicon/mountex/apple-icon-144x144.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/favicon/mountex/android-icon-192x192.png"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"hu"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"